
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 34.083 34.083"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.501 29.572a2.497 2.497 0 01-1.768-4.266l8.264-8.264L.733 8.779a2.498 2.498 0 010-3.535 2.498 2.498 0 013.535 0l10.031 10.031c.469.469.731 1.104.731 1.768s-.264 1.298-.731 1.769l-10.03 10.03a2.502 2.502 0 01-1.768.73zm31.582-2.5a2.5 2.5 0 00-2.5-2.5H16.946a2.5 2.5 0 100 5h14.637a2.5 2.5 0 002.5-2.5z"}})])
          )
        }
      }
    